export default "__VITE_ASSET__BFbPZG1u__"